import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ButtonBaseDefault from './ButtonBase';
import i18nMessages from '../../../constants/messages/pt-BR';

const styleClass = {
  default: '',
  raised: 'py-2 px-3 rounded shadow',
  rounded: 'py-2 px-3 rounded-full',
};

class Button extends React.Component {
  getClass = () => {
    let { variant, className } = this.props;

    className = classNames(
      className,
      {
        [styleClass.default]: variant === i18nMessages.simple,
      },
      {
        [styleClass.raised]: variant === i18nMessages.raised,
      },
      {
        [styleClass.rounded]: variant === i18nMessages.rounded,
      }
    );

    return className;
  };

  render() {
    let { variant, children, className, ...other } = this.props;

    className = this.getClass();

    return (
      <ButtonBaseDefault className={className} {...other}>
        {children}
      </ButtonBaseDefault>
    );
  }
}

Button.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['simple', 'raised', 'rounded']),
  handler: PropTypes.func,
  children: PropTypes.node,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const Button = ({prop = val, variant = 'simple', className = '', children = '', handler = () => null }) =>

export default Button;
